import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";

const CancelDialog = ({
  title,
  text,
  button,
  onConfirm,
  handleClose,
}: {
  title?: string;
  text?: string;
  button?: string;
  onConfirm?: () => void;
  handleClose: () => void;
}) => {
  return (
    <Dialog open={true} onClose={handleClose}>
      <DialogTitle>{title ?? ""}</DialogTitle>
      <DialogContent sx={{ width: "445px" }}>{text ?? ""}</DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button
          onClick={() => {
            handleClose();
          }}
          color="primary"
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onConfirm?.();
          }}
        >
          {button ?? "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
